<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberEntry/edit?id=' + $route.query.member_id)" class="btn-grey"><i
                class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-6 text-right">
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="submitData">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="editData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Sales</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="sales" v-model="editData.sales_id" class="form-control border-bottom"
                    v-validate="'required'">
                    <option :value="null" selected>Please select</option>
                    <!-- <option :value="0" v-if="transaction_type_id === 5">Personal Trainer</option> -->
                    <option v-for="item in dataSales" :value="item.id" :key="item.id">{{ item.fullname }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('sales') }}</span>
                </b-col>
              </b-row>



              <b-row class="mb-20"
                v-show="transaction_type_id === 5 && (editData.sales_id === '0' || editData.sales_id === 0)">
                <b-col sm="2">
                  <label>Personal Trainer</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="pt" v-model="editData.personal_trainer_id" class="form-control border-bottom"
                    v-validate="'required'">
                    <option value="null" selected>Please select</option>
                    <option v-for="(item, index) in itemPt" :value="item.id" :key="index">{{ item.name }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('pt') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Date</label>
                </b-col>
                <b-col sm="10">
                  <flat-pickr :config="config" v-model="editData.created_at" name="date" class="w-100"></flat-pickr>
                  <span class="error">{{ errors.first('date') }}</span>
                </b-col>
              </b-row>

              <!-- Doc Agreement -->
              <b-row class="mb-20"
                v-if="transaction_type_id === 1 || transaction_type_id === 2 || transaction_type_id === 3 || transaction_type_id === 12">
                <b-col sm="2">
                  <label>Form Type</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="document_type" v-model="editData.doc_agreement_name" class="form-control">
                    <option value="" selected>Please select</option>
                    <option value="form_paradigm_lp_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha,
                      Beta, Omega) (LP)</option>
                    <option value="form_paradigm_lp_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun
                      (Alpha, Beta, Omega) (LP)</option>
                    <option value="form_paradigm_lp_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha,
                      Beta, Omega) (LP)</option>
                    <option value="form_paradigm_lp_4.hbs">P4 : Corporate dan Family Membership CC sendiri (LP)</option>
                    <option value="form_paradigm_lp_5.hbs">P5 : Corporate dan Family Membership CC orang lain (LP)
                    </option>
                    <option value="form_paradigm_lp_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun (LP)
                    </option>
                    <option value="form_paradigm_lp_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial) (LP)
                    </option>
                    <option value="form_paradigm_lp_8.hbs">P8 : Beta Plus Membership (LP)</option>
                    <option value="form_paradigm_lp_9.hbs">P9 : Agreement membership (LP)</option>

                    <option value="form_paradigm_sq_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha,
                      Beta, Omega) (SQ)</option>
                    <option value="form_paradigm_sq_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun
                      (Alpha, Beta, Omega) (SQ)</option>
                    <option value="form_paradigm_sq_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha,
                      Beta, Omega) (SQ)</option>
                    <option value="form_paradigm_sq_4.hbs">P4 : Corporate dan Family Membership CC sendiri (SQ)</option>
                    <option value="form_paradigm_sq_5.hbs">P5 : Corporate dan Family Membership CC orang lain (SQ)
                    </option>
                    <option value="form_paradigm_sq_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun (SQ)
                    </option>
                    <option value="form_paradigm_sq_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial) (SQ)
                    </option>
                    <option value="form_paradigm_sq_8.hbs">P8 : Beta Plus Membership (SQ)</option>

                    <option value="form_paradigm_sms_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun
                      (Alpha, Beta, Omega) (SMS)</option>
                    <option value="form_paradigm_sms_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun
                      (Alpha, Beta, Omega) (SMS)</option>
                    <option value="form_paradigm_sms_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun
                      (Alpha, Beta, Omega) (SMS)</option>
                    <option value="form_paradigm_sms_4.hbs">P4 : Corporate dan Family Membership CC sendiri (SMS)
                    </option>
                    <option value="form_paradigm_sms_5.hbs">P5 : Corporate dan Family Membership CC orang lain (SMS)
                    </option>
                    <option value="form_paradigm_sms_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun (SMS)
                    </option>
                    <option value="form_paradigm_sms_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial)
                      (SMS)</option>
                    <option value="form_paradigm_sms_8.hbs">P8 : Beta Plus Membership (SMS)</option>

                    <!-- <option value="form_paradigm_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha, Beta, Omega)</option>
                      <option value="form_paradigm_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun (Alpha, Beta, Omega)</option>
                      <option value="form_paradigm_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha, Beta, Omega)</option>
                      <option value="form_paradigm_4.hbs">P4 : Corporate dan Family Membership CC sendiri</option>
                      <option value="form_paradigm_5.hbs">P5 : Corporate dan Family Membership CC orang lain</option>
                      <option value="form_paradigm_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun</option>
                      <option value="form_paradigm_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial)</option>
                      <option value="form_paradigm_8.hbs">P8 : Beta Plus Membership</option> -->
                    <option value="form_paradigm_9.hbs">Membership DS</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('document_type') }}</span>
                </b-col>
              </b-row>

              <!-- add pt session -->
              <template v-if="transaction_type_id === 5">
                <!-- <b-row class="mb-20">
                      <b-col sm="2">
                        <label>PT Session</label>
                      </b-col>
                      <b-col sm="10">
                        <b-form-input v-model="pt_session" name="price_per_session" type="text" disabled></b-form-input>
                        <span class="error">{{ errors.first('price_per_session') }}</span>
                      </b-col>
                    </b-row> -->

                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>PT Session</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select @change="getPtSessionData" class="border-bottom" name="pt_session"
                      v-validate="'required'" v-model="editData.pt_session_id">
                      <option :value="null">Please select</option>
                      <option v-for="itemSession in itemPtSession" :key="itemSession.id" :value="itemSession.id">
                        {{ itemSession.name }}</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('ptSession.pt_session') }}</span>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Price Bef disc</label>
                  </b-col>
                  <b-col sm="10">
                    <money class="form-control border-bottom bg-transparent" v-model="priceBeforeDisc"
                      name="priceBeforeDisc" disabled v-bind="moneyNoPrefix"></money>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Voucher</label>
                  </b-col>
                  <b-col sm="10">
                    <money class="form-control border-bottom bg-transparent" v-model="voucher" name="voucher" disabled
                      v-bind="moneyNoPrefix"></money>
                  </b-col>
                </b-row>
              </template>

              <!-- Membership Type -->
              <b-row class="mb-20"
                v-if="transaction_type_id === 2 || transaction_type_id === 3 || transaction_type_id === 12">
                <b-col sm="2">
                  <label>Membership Type</label>
                </b-col>
                <b-col sm="10">
                  <!-- <b-form-input v-model="membership_type_name" name="membership_type_name" type="text" disabled></b-form-input>
                  <span class="error">{{ errors.first('price_per_session') }}</span> -->
                  <b-form-select v-validate="'required'" name="type_membership" @change="changeMembership"
                    v-model="editData.membership_id" class="form-control">
                    <option :value="null" selected>Please select</option>
                    <option v-for="item in itemsMembership" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('type_membership') }}</span>
                </b-col>
              </b-row>

              <!-- hide for transaction type = 5 -->
              <template v-if="transaction_type_id !== 5">
                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Processing Fee</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editData.processing_fee" name="processing_fee"
                      v-validate="'required|numeric'" type="text"></b-form-input>
                    <span class="error">{{ errors.first('processing_fee') }}</span>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Prorate</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editData.pro_rate" name="pro_rate" v-validate="'required|numeric'"
                      type="text"></b-form-input>
                    <span class="error">{{ errors.first('pro_rate') }}</span>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>First Month</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editData.first_month" name="first_month" v-validate="'required|numeric'"
                      type="text"></b-form-input>
                    <span class="error">{{ errors.first('first_month') }}</span>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Last Month</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editData.last_month" name="last_month" v-validate="'required|numeric'"
                      type="text"></b-form-input>
                    <span class="error">{{ errors.first('last_month') }}</span>
                  </b-col>
                </b-row>
              </template>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Total</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.gross_amount" name="gross_amount" v-validate="'required|numeric'"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first('gross_amount') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20" v-if="transaction_type_id === 17 || transaction_type_id === 2">
                <b-col sm="2">
                  <label>Alpha Session Price</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.alpha_session_price" name="alpha_session_price"
                    v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('alpha_session_price') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20"
                v-if="transaction_type_id === 17 || (transaction_type_id === 2 && membership_id === 33) || transaction_type_id === 5">
                <b-col sm="2">
                  <label>Price per Session</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.price_per_session" name="price_per_session"
                    v-validate="'required|numeric'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('price_per_session') }}</span>
                </b-col>
              </b-row>

              <!-- Hide for transaction type 5 -->
              <template v-if="transaction_type_id !== 5">
                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Is Comission</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select name="is_comission" v-model="editData.is_comission">
                      <option :value="null">Please select</option>
                      <option :value="1">Yes</option>
                      <option :value="0">No</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('is_comission') }}</span>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Is Delay</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select name="is_delay" v-model="editData.is_delay">
                      <option :value="null">Please select</option>
                      <option :value="1">Yes</option>
                      <option :value="0">No</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('is_delay') }}</span>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Is Pending</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select name="is_pending_comission" v-model="editData.is_pending_comission">
                      <option :value="null">Please select</option>
                      <option :value="1">Yes</option>
                      <option :value="0">No</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('is_pending_comission') }}</span>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Is Agree</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select name="is_pending_comission" v-model="editData.is_agree">
                      <option :value="null">Please select</option>
                      <option :value="1">Yes</option>
                      <option :value="0">No</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('is_pending_comission') }}</span>
                  </b-col>
                </b-row>

                <b-row class="mb-20">
                  <b-col sm="2">
                    <div class="label-name">Membership Contract Category</div>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select name="membership_contract_category_id"
                      v-model="editData.membership_contract_category_id" class="form-control border-bottom">
                      <option value="null" selected>Please select</option>
                      <option v-for="(item, index) in dataMembershipContract" :value="item.id" :key="index">
                        {{ item.name }}</option>
                    </b-form-select>
                  </b-col>
                </b-row>
              </template>

              <b-row class="mb-20">
                <b-col sm="2">
                  <div class="label-name">Payment 1</div>
                </b-col>
                <b-col sm="5">
                  <div class="mb-20">
                    <b-form-select name="paymentType1" @change="changePaymentType1" v-model="editData.payment_type_id_1"
                      class="form-control border-bottom">
                      <option :value="null" selected>Please select</option>
                      <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{ item.name }}</option>
                    </b-form-select>
                  </div>
                  <div class="mb-10">
                    <b-form-radio-group @change="changePaymentCard1" class="radio-custom-list"
                      :disabled="[1, 6, 9].includes(editData.payment_type_id_1)" name="paymentCard1"
                      v-model="editData.payment_card_id_1">
                      <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{
                        item.name
                      }}</b-form-radio>
                    </b-form-radio-group>
                    <!-- <div v-if="![1,9].includes(editData.payment_card_id_1) && editData.payment_card_id_1 != null && editData.payment_card_id_1 == null">
                      <span class="error">The payment_card_id_1 field is required.</span>
                    </div> -->
                    <div v-if="![1, 9].includes(editData.payment_card_id_1) && editData.payment_card_id_1 == null">
                      <span class="error">The payment_card_id_1 field is required.</span>
                    </div>
                  </div>
                </b-col>
                <b-col sm="5">
                  <money class="form-control border-bottom custom-currency w-100 bg-transparent"
                    v-model="editData.payment_amount_1" v-bind="money"></money>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <div class="label-name">Payment 2</div>
                </b-col>
                <b-col sm="5">
                  <div class="mb-20">
                    <b-form-select name="paymentType2" @change="changePaymentType2" v-model="editData.payment_type_id_2"
                      class="form-control border-bottom">
                      <option :value="null" selected>Please select</option>
                      <option v-for="item in itemsPaymentType2" :key="item.id" :value="item.id">{{ item.name }}</option>
                    </b-form-select>
                  </div>
                  <div class="mb-10">
                    <b-form-radio-group @change="changePaymentCard2" class="radio-custom-list"
                      :disabled="editData.payment_type_id_2 == 1 || editData.payment_type_id_2 == 6" name="paymentCard2"
                      v-model="editData.payment_card_id_2">
                      <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id" :value="item.id">{{
                        item.name
                      }}</b-form-radio>
                    </b-form-radio-group>
                  </div>
                </b-col>
                <b-col sm="5">
                  <money class="form-control border-bottom custom-currency w-100 bg-transparent" disabled
                    v-model="editData.payment_amount_2" :value="paymentLeft" v-bind="money"></money>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Notes</label>
                </b-col>
                <b-col sm="10">
                  <textarea name="notes" v-validate="'required'" v-model="editData.notes" class="w-100"
                    rows="4"></textarea>
                  <span class="error">{{ errors.first('notes') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Type</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="document_type" v-model="editData.doc_agreement_name" class="form-control">
                    <option value="null" selected>Please select</option>
                    <!-- <option value="form_paradigm_1.hbs">Form Paradigm 1</option>
                    <option value="form_paradigm_2.hbs">Form Paradigm 2</option>
                    <option value="form_paradigm_3.hbs">Form Paradigm 3</option>
                    <option value="form_paradigm_4.hbs">Form Paradigm 4</option>
                    <option value="form_paradigm_5.hbs">Form Paradigm 5</option>
                    <option value="form_paradigm_6.hbs">Form Paradigm 6</option>
                    <option value="form_paradigm_7.hbs">Form Paradigm 7</option>
                    <option value="form_paradigm_8.hbs">Form Paradigm 8</option>
                    <option value="form_paradigm_9.hbs">Membership DS</option> -->
                    <option value="form_paradigm_lp_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha,
                      Beta, Omega)
                      (LP)</option>
                    <option value="form_paradigm_lp_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun
                      (Alpha, Beta,
                      Omega) (LP)</option>
                    <option value="form_paradigm_lp_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha,
                      Beta, Omega)
                      (LP)</option>
                    <option value="form_paradigm_lp_4.hbs">P4 : Corporate dan Family Membership CC sendiri (LP)</option>
                    <option value="form_paradigm_lp_5.hbs">P5 : Corporate dan Family Membership CC orang lain (LP)
                    </option>
                    <option value="form_paradigm_lp_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun (LP)
                    </option>
                    <option value="form_paradigm_lp_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial) (LP)
                    </option>
                    <option value="form_paradigm_lp_8.hbs">P8 : Beta Plus Membership (LP)</option>

                    <option value="form_paradigm_lp_9.hbs">P9 : Agreement membership (LP)</option>

                    <option value="form_paradigm_sq_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha,
                      Beta, Omega)
                      (SQ)</option>
                    <option value="form_paradigm_sq_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun
                      (Alpha, Beta,
                      Omega) (SQ)</option>
                    <option value="form_paradigm_sq_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha,
                      Beta, Omega)
                      (SQ)</option>
                    <option value="form_paradigm_sq_4.hbs">P4 : Corporate dan Family Membership CC sendiri (SQ)</option>
                    <option value="form_paradigm_sq_5.hbs">P5 : Corporate dan Family Membership CC orang lain (SQ)
                    </option>
                    <option value="form_paradigm_sq_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun (SQ)
                    </option>
                    <option value="form_paradigm_sq_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial) (SQ)
                    </option>
                    <option value="form_paradigm_sq_8.hbs">P8 : Beta Plus Membership (SQ)</option>

                    <option value="form_paradigm_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun (Alpha,
                      Beta, Omega)
                    </option>
                    <option value="form_paradigm_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun (Alpha,
                      Beta, Omega)
                    </option>
                    <option value="form_paradigm_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun (Alpha,
                      Beta, Omega)
                    </option>
                    <option value="form_paradigm_4.hbs">P4 : Corporate dan Family Membership CC sendiri</option>
                    <option value="form_paradigm_5.hbs">P5 : Corporate dan Family Membership CC orang lain</option>
                    <option value="form_paradigm_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun</option>
                    <option value="form_paradigm_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial)</option>
                    <option value="form_paradigm_8.hbs">P8 : Beta Plus Membership</option>

                    <option value="form_paradigm_sms_1.hbs">P1 : Dues COE CC sendiri dan usia lebih dari 17 tahun
                      (Alpha, Beta, Omega)
                      (SMS)</option>
                    <option value="form_paradigm_sms_2.hbs">P2 : Dues COE CC orang lain dan usia lebih dari 17 tahun
                      (Alpha, Beta,
                      Omega) (SMS)</option>
                    <option value="form_paradigm_sms_3.hbs">P3 : Dues COE CC orang lain dan usia dibawah 17 tahun
                      (Alpha, Beta, Omega)
                      (SMS)</option>
                    <option value="form_paradigm_sms_4.hbs">P4 : Corporate dan Family Membership CC sendiri (SMS)
                    </option>
                    <option value="form_paradigm_sms_5.hbs">P5 : Corporate dan Family Membership CC orang lain (SMS)
                    </option>
                    <option value="form_paradigm_sms_6.hbs">P6 : Family Membership CC Orang lain dibawah 17 tahun (SMS)
                    </option>
                    <option value="form_paradigm_sms_7.hbs">P7 : Term Membership (Term, One Month, Advocacy, Trial)
                      (SMS)</option>
                    <option value="form_paradigm_sms_8.hbs">P8 : Beta Plus Membership (SMS)</option>

                    <option value="form_paradigm_9.hbs">Membership DS</option>
                    <option value="form_paradigm_9_efd_2024.hbs">Membership DS EFD</option>
                    <option value="form_paradigm_9_sq_efd_2024.hbs">Membership SQ EFD</option>
                    <option value="form_paradigm_9_lp_efd_2024.hbs">Membership LP EFD</option>
                  </b-form-select>
                  <!-- <span class="error">{{ errors.first('ptSession.installment_month') }}</span> -->
                </b-col>
              </b-row>
              <template
                v-if="transaction_type_id === 5 || transaction_type_id === 2 || transaction_type_id === 3 || transaction_type_id === 12">
                <b-row class="mb-20" v-if="transaction_type_id === 5">
                  <b-col sm="2">
                    <label>PT Session Category</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="border-bottom" name="session_contract_category_id"
                      v-model="editData.session_contract_category_id">
                      <option value="1">New</option>
                      <option value="2">Renew</option>
                    </b-form-select>
                  </b-col>
                </b-row>
                <b-row class="mb-20">
                  <b-col sm="2">
                    <label>Payment Type</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="border-bottom" name="session_payment_type_id"
                      v-model="editData.session_payment_type_id"
                      @change="editData.installment_month = (editData.session_payment_type_id == 1) ? '' : editData.installment_month">
                      <option value="1">Regular</option>
                      <option value="2">Installment</option>
                    </b-form-select>
                  </b-col>
                </b-row>
                <b-row class="mb-20" v-if="editData.session_payment_type_id == '2'">
                  <b-col sm="2">
                    <label>Installment Month</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="border-bottom" name="installment_month" v-validate="'required'"
                      v-model="editData.installment_month">
                      <option value="3">3</option>
                      <option value="6">6</option>
                      <option value="12">12</option>
                    </b-form-select>
                    <span class="error">{{ errors.first('ptSession.installment_month') }}</span>
                  </b-col>
                </b-row>




              </template>

              <div class="text-right">
                <button :disabled="disabledExpiredDate" type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
// import { Callout } from '@coreui/vue'
import axios from 'axios'
// import { Auth } from '@/api'
import moment from 'moment'
import { Money } from 'v-money'

export default {
  name: 'editBooking',
  components: { Money },
  data: function () {
    return {
      loadingActive: false,
      disabledExpiredDate: false,
      dataBranch: [],
      dataSales: [],
      itemPt: [],
      itemPtSession: [],
      dataMembershipContract: [],
      changePassData: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      transaction_type_id: '',
      membership_id: '',
      pt_session: '',
      membership_type_name: '',
      salesId: 0,
      memberData: {},
      priceBeforeDisc: 0,
      voucher: 0,
      editData: {
        sales_id: null,
        branch_id: null,
        membership_contract_category_id: null,
        gross_amount: '',
        alpha_session_price: '',
        price_per_session: '',
        processing_fee: '',
        pro_rate: '',
        first_month: '',
        last_month: '',
        created_at: '',
        notes: '',
        is_comission: null,
        is_delay: null,
        is_pending_comission: null,
        payment_card_id_1: null,
        payment_card_id_2: null,
        payment_amount_1: '',
        payment_amount_2: '',
        payment_type_id_1: '',
        payment_type_id_2: '',
        session_contract_category_id: '',
        installment_month: '',
        session_payment_type_id: '',
        revenue_pos1: '',
        revenue_pos2: '',
        membership_id: '',
        membership_name: '',
        doc_agreement_name: '',
        pt_session_id: null,
        is_agree: ''
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'IDR ',
        suffix: '',
        precision: 0,
        masked: false
      },
      moneyNoPrefix: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      itemsPaymentCard: [],
      itemsPaymentType: [],
      itemsPaymentType2: [],
      config: {
        altInput: true,
        altFormat: 'j F Y H:i',
        dateFormat: 'Y-m-d H:i',
        enableTime: true,
        enableSeconds: true,
        time_24hr: true
      },
      confirm_password: '',
      imageData: '',
      imgUpload: null,
      salesRole: '',
      branchSalesId: '',
      selectedBranchId: null,
      file: null,
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    disabledBackDate() {
      // disable if month is more than current month
      // this.disabledEpiredDate = true



    },
    changeBranch(ev) {
      this.selectedBranchId = ev
      this.fetchData()
      console.log('BRANCH: ', ev)
    },
    changeMembership(event) {
      let membership = this.itemsMembership.filter(row => row.id === event)[0]
      this.editData.membership_id = event
      this.editData.membership_name = membership.name
    },
    getPtSessionData(event) {
      // console.log(event)
      this.editData.pt_session_id = event
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {

          this.$swal({
            title: 'Are you sure?',
            text: 'You are about to submit this Transaction data and waiting for approval',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Submit now!',
            cancelButtonText: 'No, Cancel it!',
            showCloseButton: true,
            showLoaderOnConfirm: false
          }).then((confirm) => {
            if (confirm.value) {
              const payload = {
                entity_id: this.$route.query.id,
                request_data: this.editData,
                action: 'EDIT',
                notes: `Edit Transaction`,
                module_type: 'EDIT_TRANSACTION',
                description: `Edit Transaction data with trx id ${this.$route.query.id} and member ${this.$route.query.member_id}--${this.memberData.first_name} | notes: ${this.editData.notes}`
              }

              // console.log('payload', payload)

              this.loadingActive = true
              // add to approval request
              axios.post('crm/v1/approval_request/get_aprroval', payload).then(response => {
                this.loadingActive = false
                this.$swal('Successfully! Waiting for Approval', 'Data has been submitted and waiting for approval!', 'success')
                // this.$router.push('/memberEntry/edit?id=' + this.$route.query.member_id)
              }).catch((error) => {
                this.loadingActive = false
                console.log('Error', error)
                this.$swal('Failed!', error.response.data.error, 'error')
              })
            }
          })


          // remark when approval future is ready
          // axios.put('transaction/v1/transaction/detail?id=' + this.$route.query.id, this.editData).then(response => {
          //   this.$router.push('/memberEntry/edit?id=' + this.$route.query.member_id)
          //   this.$toast.success('data saved successfully!', 'Success', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          // }).catch(error => {
          //   // console.log('error log', error)
          //   this.$toast.success('cant saved data!', 'Error', {
          //     position: 'topCenter',
          //     icon: 'icon-envelope',
          //     progressBarColor: 'rgb(0, 255, 184)',
          //     theme: 'dark',
          //     backgroundColor: '#565c70',
          //     messageColor: '#fff'
          //   })
          // })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    changePaymentType1(event) {
      if (event === 1) {
        this.editData.payment_card_id_1 = null
      } else if (event === 6) {
        this.editData.payment_card_id_1 = 1
      } else {
        this.editData.payment_card_id_1 = null
      }
    },
    changePaymentType2(event) {
      if (event === 1) {
        this.editData.payment_card_id_2 = null
      } else if (event === 6) {
        this.editData.payment_card_id_2 = 1
      } else {
        this.editData.payment_card_id_2 = null
      }
    },
    // add paymentcard type
    async changePaymentCard1(event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType = payment_card.data.data.rows
    },
    async changePaymentCard2(event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType2 = payment_card.data.data.rows
    },
    // end paymentcard
    fetchData() {
      axios.get('transaction/v1/transaction/detail?id=' + this.$route.query.id).then(response => {
        console.log(response.data.data)
        this.memberData = response.data.data.member
        this.salesId = response.data.data.sales_id
        this.transaction_type_id = response.data.data.transaction_type_id
        this.membership_id = response.data.data.membership_id
        this.editData.gross_amount = response.data.data.gross_amount
        this.editData.alpha_session_price = response.data.data.alpha_session_price
        this.editData.price_per_session = response.data.data.price_per_session
        this.editData.processing_fee = response.data.data.transaction_detail ? response.data.data.transaction_detail.processing_fee_before_tax : 0
        this.editData.first_month = response.data.data.transaction_detail ? response.data.data.transaction_detail.first_month_before_tax : 0
        this.editData.pro_rate = response.data.data.transaction_detail ? response.data.data.transaction_detail.pro_rate_before_tax : 0
        this.editData.last_month = response.data.data.transaction_detail ? response.data.data.transaction_detail.last_month_before_tax : 0
        this.editData.sales_id = response.data.data.sales_id
        this.editData.personal_trainer_id = response.data.data.personal_trainer_id
        this.editData.created_at = response.data.data.created_at
        this.editData.membership_contract_category_id = response.data.data.membership_contract_category_id
        this.editData.payment_type_id_1 = response.data.data.payment_type_id_1
        this.editData.payment_type_id_2 = response.data.data.payment_type_id_2
        this.editData.payment_card_id_1 = response.data.data.payment_card_id_1
        this.editData.payment_card_id_2 = response.data.data.payment_card_id_2
        this.editData.payment_amount_1 = response.data.data.payment_amount_1
        this.editData.payment_amount_2 = response.data.data.payment_amount_2
        // this.editData.notes = response.data.data.notes
        this.editData.is_comission = response.data.data.is_comission
        this.editData.is_delay = response.data.data.is_delay
        this.editData.is_pending_comission = response.data.data.is_pending_comission
        this.editData.session_contract_category_id = response.data.data.session_contract_category_id
        this.editData.session_payment_type_id = response.data.data.session_payment_type_id
        this.editData.installment_month = response.data.data.installment_month
        this.editData.revenue_pos1 = response.data.data.revenue_pos1
        this.editData.revenue_pos2 = response.data.data.revenue_pos2

        this.editData.pt_session_id = response.data.data.pt_session_id
        this.editData.is_agree = response.data.data.is_agree

        // enabled for selected branch
        if (this.selectedBranchId === null) {
          this.editData.branch_id = response.data.data.branch_id
        } else {
          this.editData.branch_id = this.selectedBranchId
        }

        // price before disc buying session
        if (response.data.data.transaction_type_id == 5 && response.data.data.pt_session) {
          let price_per_session = response.data.data.pt_session.price
          let qty = response.data.data.pt_session.quantity
          response.data.data.voucher_amount = response.data.data.voucher_amount ? response.data.data.voucher_amount : 0
          this.priceBeforeDisc = price_per_session * qty
        }

        this.voucher = response.data.data.voucher_amount ? response.data.data.voucher_amount : 0

        this.editData.membership_id = response.data.data.membership_id
        this.editData.membership_name = response.data.data.membership_name
        this.editData.is_agree = response.data.data.is_agree

        this.editData.doc_agreement_name = response.data.data.doc_agreement_name

        const year = moment(this.editData.created_at).format('YYYY')
        const month = moment(this.editData.created_at).format('M')

        axios.get('crm/v1/closing_period/member_pt_session?year=' + year + '&bulan=' + month).then(response => {
          const data = response.data.data
          this.disabledExpiredDate = true
        }).catch(error => {
          // this.disabledExpiredDate = false
          console.log('error', error)
        })

        if (response.data.data.payment_card_id_1) {
          axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + response.data.data.payment_card_id_1).then(response => {
            this.itemsPaymentType = response.data.data.rows
          }).catch(error => {
            console.log('error', error)
          })
        }
        if (response.data.data.payment_card_id_2) {
          axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + response.data.data.payment_card_id_2).then(response => {
            this.itemsPaymentType2 = response.data.data.rows
          }).catch(error => {
            console.log('error', error)
          })
        }
        if (!response.data.data.payment_card_id_1 && !response.data.data.payment_card_id_2) {
          axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1').then(response => {
            this.itemsPaymentType = response.data.data.rows
            this.itemsPaymentType2 = response.data.data.rows
          }).catch(error => {
            console.log('error', error)
          })
        }
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc').then(response => {
        this.itemPt = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/membership_contract_category/').then(response => {
        this.dataMembershipContract = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/sales?sorting=fullname&sorting_type=asc').then(response => {
        this.dataSales = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/membership?sorting=name&sorting_type=asc&status=active').then(response => {
        this.itemsMembership = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      // update bro
      axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1').then(response => {
        this.itemsPaymentType = response.data.data.rows
        this.itemsPaymentType2 = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active').then(response => {
        this.itemsPaymentCard = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios
        .get("fitness/v1/pt_session?sorting=name&sorting_type=asc&is_deleted=3")
        .then(response => {
          this.itemPtSession = response.data.data.rows;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  computed: {
    paymentLeft: function () {
      if (String(this.editData.payment_amount_1).length > String(this.editData.gross_amount).length) {
        // console.log('test')
        this.editData.payment_amount_2 = 0
      } else {
        this.editData.payment_amount_2 = this.editData.gross_amount - this.editData.payment_amount_1
        this.editData.payment_amount_2 = Math.abs(this.editData.payment_amount_2)
      }
    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style>
.testing:hover {
  background-color: red !important;
  display: none;
}
</style>
